import * as Yup from 'yup'

export const validationSchemasProcesoJudicial = (agrupaCompetencia) => {
    let validation = {};

    validation.competencia = Yup.string().required('Este campo es obligatorio.');
    validation.juridiccion = Yup.string().required('Este campo es obligatorio.');
    //validation.departamento = Yup.string().required('Este campo es obligatorio.');
    //validation.municipio = Yup.string().required('Este campo es obligatorio.')
    if (agrupaCompetencia != 0) {
        validation.despacho = Yup.string().required('Este campo es obligatorio.');;
    }
    validation.nroRadicado = Yup.string()
                    .required('Este campo es obligatorio.')
                    .matches(/^[0-9-/]+$/, "Se permite ingreso de números y caracteres: '-' y '/'");
    //validation.fechaIngresoCausa = Yup.string().required('Este campo es obligatorio.');

    return Yup.object().shape(validation);
}

export const validationSchemasSeguimientoHito = (esAudiencia, limitePesadoBytes = 20 * 1000000) => {
    let validation = {};

    validation.codHitoJudicial = Yup.string().required('Este campo es obligatorio.');
    //validation.fechaHitoJudicial = Yup.string().required('Este campo es obligatorio.');
    if (esAudiencia) validation.fechaAudiencia = Yup.string().required('Este campo es obligatorio.');

    validation.file = Yup
        .mixed()
        .test('fileSize', `Tamaño máximo del archivo ${limitePesadoBytes / 1000000}MB.`,
            (value) => {
                if (!value) return true;
                return value.size <= limitePesadoBytes;
            })

    return Yup.object().shape(validation);
}